import image1 from "../images/memberships/Enmascarar grupo 7.png";
import diamond from "../images/memberships/diamond.png";

const memberships = [
    {
        id: 0,
        image: image1,
        icon: diamond,
        title: "Reto Blender",
        price: "14.99",
        price_before: "69",
        items: [
            {
                item: "Clases online en vídeo.",
                more: null,
            },
            {
                item: "Materiales y referencias para descargar.",
                more: null,
            },
            {
                item: "Descarga los vídeos del curso.",
                more: "Tendrás la opción de descargar los vídeos del curso. Este es el único curso con opción de descarga. Ningún otro curso en Libel tiene esa opción. Recuerda revisar nuestros Términos y Condiciones.",
            },
        ],
        urls: [
            {
                name: "Paga con Paypal",
                url: "https://cursos.libel.academy/courses/aprende-blender-3-0-en-15-dias",
            },
            {
                name: "Paga con Tarjeta",
                url: "https://payco.link/1319230",
            },
        ],
    },
    // {
    //     id: 1,
    //     image: image2,
    //     icon: diamond,
    //     title: "Único Pago",
    //     price: "475",
    //     price_before: "600",
    //     items: [
    //         {
    //             item: "Acceso a todos los entrenamientos",
    //             more: "Tendrás a tu disposición todo el contenido del máster.",
    //         },
    //         {
    //             item: "Acceso a feedback en vivo y materiales.",
    //             more: "Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.",
    //         },
    //         {
    //             item: "Acceso por un año al contenido.",
    //             more: "El año de acceso se empieza a contar a partir de la activación del contenido en tu cuenta..",
    //         },
    //         { item: "Acceso a Discord privado", more: null },
    //     ],
    //     urls: [
    //         {
    //             name: "Pagar con PayPal",
    //             url: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=LS5H52E8KT66Y",
    //         },
    //         {
    //             name: "Pagar con Tarjeta",
    //             url: "https://payco.link/1288432",
    //         },
    //     ],
    // },
];

export default memberships;
